var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHiddenIcon = function SvgHiddenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 13c0 1.11-6 10-15 10a13.83 13.83 0 0 1-1.83-.13l.91-1.93A7 7 0 0 0 15 21a8 8 0 0 0 5.51-13.79l1.18-2.52C26.84 7.32 30 12.2 30 13Zm-15 6a6 6 0 0 0 4.6-9.85Zm6.5-17.44-11 23.54-2.8-1.29 1.06-2.28C3.34 19 0 13.83 0 13 0 11.89 6 3 15 3a13.66 13.66 0 0 1 2.34.22l1.39-3ZM9.89 19.13l.88-1.88a6 6 0 0 1-.37-8.09A2.49 2.49 0 0 0 12.5 13h.28l1.8-3.85a2.47 2.47 0 0 0-3.42-.72A6 6 0 0 1 15 7a4.89 4.89 0 0 1 .55 0l.9-1.91A7.75 7.75 0 0 0 15 5a8 8 0 0 0-5.11 14.13Z"
  })));
};

export default SvgHiddenIcon;